'use client';
import React, { useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem } from "flowbite-react";
import { HiHome } from "react-icons/hi";
import Link from 'next/link';
import { hostName } from '@/Config/hostConfig';

type Props = {
    items: {
        name: string;
        href: string;
    }[]
}

const MainBreadCrumb = ({ items }: Props) => {

    useEffect(() => {
        const breadcrumbList = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Accueil",
                    "item": hostName + "/"
                },
                ...items.map((item, index) => ({
                    "@type": "ListItem",
                    "position": index + 2,
                    "name": item.name,
                    "item": `${hostName}${item.href}`
                }))
            ]
        };
        // Fonction pour mettre à jour le script des données structurées
        const updateStructuredData = () => {
            const existingScript = document.getElementById('breadcrumb-list-script');
            if (existingScript) {
                existingScript.remove();
            }

            const script = document.createElement('script');
            script.id = 'breadcrumb-list-script';
            script.type = 'application/ld+json';
            script.text = JSON.stringify(breadcrumbList);
            document.head.appendChild(script);
        };

        // Mettre à jour le script des données structurées à chaque changement d'items
        updateStructuredData();

        // Nettoyage lors du démontage ou changement de page
        return () => {
            const script = document.getElementById('breadcrumb-list-script');
            if (script) {
                script.remove();
            }
        };
    }, [items]);

    return (
        <>
            <Breadcrumb aria-label="Fil d'ariane" className='hidden md:block mb-2'>
                <BreadcrumbItem>
                    <Link href="/">
                        <div className="flex items-center">
                            <HiHome className="me-1" /> Accueil
                        </div>
                    </Link>
                </BreadcrumbItem>
                {items.map((item, index) => (
                    <BreadcrumbItem key={index}>
                        <Link href={item.href}>
                            {item.name}
                        </Link>
                    </BreadcrumbItem>
                ))}
            </Breadcrumb>
        </>
    );
}

export default MainBreadCrumb;